export default __webpack_public_path__ + "static/media/logo.786490ee.png";